// Clerk reads its palette from `appearance.variables` on whichever component (or
// provider) mounts it. Setting appearance on ClerkProvider makes it cascade to
// every Clerk surface — the OrganizationSwitcher trigger, its popover, AND the
// full-page UserProfile / OrganizationProfile modals that open off "Manage
// account" / "Manage organization". Passing appearance only on the individual
// <UserButton /> / <OrganizationSwitcher /> themes the popover but not those
// modals, which is why they previously painted white.
//
// `isDark` is derived from our own theme state (use-dark-mode → data-bs-theme),
// so Clerk's chrome follows the same toggle as the rest of the app.
export function clerkAppearance(isDark) {
    return {
        variables: isDark
            ? {
                colorPrimary: '#26ada9',
                colorBackground: '#1e293b',
                colorText: '#f1f5f9',
                colorTextSecondary: 'rgba(241, 245, 249, 0.7)',
                colorInputBackground: '#334155',
                colorInputText: '#f1f5f9',
                colorNeutral: '#f1f5f9',
            }
            : {
                colorPrimary: '#26ada9',
                colorBackground: '#ffffff',
                colorText: '#111827',
                colorTextSecondary: '#6b7280',
                colorInputBackground: '#ffffff',
                colorInputText: '#111827',
                colorNeutral: '#111827',
            },
        elements: {
            // ── Suppress every "Create / Add Organisation" affordance ────
            // We've replaced Clerk's <OrganizationSwitcher> with our own
            // custom <OrgSwitcher>, but Clerk components we still embed
            // (<UserButton>, <UserProfile> modal) can also surface these
            // actions. Belt-and-braces: hide them at the Provider level
            // so the rule cascades to every Clerk-rendered surface,
            // including any future Clerk widget we adopt.
            organizationSwitcherPopoverActionButton__createOrganization: { display: 'none' },
            userButtonPopoverActionButton__createOrganization: { display: 'none' },
            userButtonPopoverActionButton__manageOrganization: { display: 'none' },
            // The Organizations tab/section inside <UserProfile> (the
            // "Manage account" modal) — Clerk's class names have shifted
            // historically so cover the older + newer selectors.
            profileSectionPrimaryButton__organizations: { display: 'none' },
            profileSection__organizations: { display: 'none' },
            'cl-userProfile__organizations': { display: 'none' },
            navbarButton__organizations: { display: 'none' },
            // Hide Clerk's built-in billing UI — we use Stripe directly.
            'cl-organizationProfile-billing': { display: 'none' },
            navbarButton__billing: { display: 'none' },
            profilePage__billing: { display: 'none' },
        },
    };
}
